<app-homepage
    [viewEventi]="viewEventi"
    [viewReservation]="viewReservation"
    [viewMdr]="viewMdr"
></app-homepage>
